import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';

import {
  SkillDepartmentLearningProgressResponse,
  SkillProgressResponse,
  SkillWeightSumResponse,
  SkillWeightSumParams,
} from '../models/skill-learning.model';
import { SKILL_PROGRESS_API } from '../constants/skill-api.constants';

@Injectable()
export class SkillProgressApiService {

  constructor(private http: Http) {}

  fetchDepartmentLearningProgress(): Observable<SkillDepartmentLearningProgressResponse> {
    return this.http
      .get(SKILL_PROGRESS_API.DEPARTMENTS)
      .map(response => response.json() as SkillDepartmentLearningProgressResponse);
  }

  fetchProgressBySpecialization(specializationId: string): Observable<SkillProgressResponse> {
    return this.http
      .get(SKILL_PROGRESS_API.BY_SPECIALIZATION(specializationId))
      .map(response => response.json() as SkillProgressResponse);
  }

  fetchUserProgress(specializationId: string): Observable<SkillProgressResponse> {
    return this.fetchProgressBySpecialization(specializationId);
  }

  fetchProgressByUser(specializationId: string, userId: string): Observable<SkillProgressResponse> {
    return this.http
      .get(SKILL_PROGRESS_API.BY_USER(specializationId, userId))
      .map(response => response.json() as SkillProgressResponse);
  }

  toggleTopicChecked(specializationId: string, topicIndex: number): Observable<void> {
    return this.http
      .post(SKILL_PROGRESS_API.TOPIC_TOGGLE(specializationId, topicIndex), null)
      .map(() => undefined);
  }

  toggleTopic(specializationId: string, topicIndex: number): Observable<void> {
    return this.toggleTopicChecked(specializationId, topicIndex);
  }

  fetchWeightSum(params: SkillWeightSumParams): Observable<SkillWeightSumResponse> {
    const url = `${SKILL_PROGRESS_API.WEIGHT_SUM}?from=${params.from}&to=${params.to}`;
    return this.http
      .get(url)
      .map(response => response.json() as SkillWeightSumResponse);
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/skill-learning/services/skill-progress-api.service.ts